import React from "react";

export default function Footer() {
  return (
    <div className="card-footer">
      Coded by <a href="https://github.com/Lotz33/weather-react">Lottie</a>
    </div>
  );
}
